// extracted by mini-css-extract-plugin
module.exports = {"container":"forum_container__hUKaO","line":"forum_line__AgN2G","time":"forum_time__DHYgX"};